import React, { useState, useEffect } from 'react';
import billingService from '../../api/billingService';
import { formatDate } from '../../utils/formatters';

const SystemLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    fetchLogs();
  }, [page]);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const res = await billingService.getUploadLogs({ page, limit: 10 });
      if (res.success) setLogs(res.data);
    } catch (error) {
      console.error('Error fetching logs:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="mb-4">
        <h4 className="fw-700 mb-1">System Logs</h4>
        <p className="text-muted small mb-0">Track status and reports of data uploads.</p>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light">
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Status</th>
                <th>Records</th>
                <th>Success / Error</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" className="text-center py-5">Loading logs...</td></tr>
              ) : logs.length === 0 ? (
                <tr><td colSpan="6" className="text-center py-5">No upload history found.</td></tr>
              ) : (
                logs.map(log => (
                  <tr key={log._id}>
                    <td className="text-xs">{formatDate(log.created_at)}</td>
                    <td><span className="badge bg-light text-dark text-xs uppercase">{log.type}</span></td>
                    <td>
                      <span className={`badge badge-soft-${log.status === 'completed' ? 'success' : log.status === 'processing' ? 'primary' : 'warning'}`}>
                        {log.status?.toUpperCase()}
                      </span>
                    </td>
                    <td className="fw-600">{log.total_records}</td>
                    <td>
                      <span className="text-success fw-600">{log.success_count}</span>
                      <span className="mx-1">/</span>
                      <span className="text-danger fw-600">{log.error_count}</span>
                    </td>
                    <td>
                      <button className="btn btn-sm btn-light text-primary" onClick={() => setSelectedLog(log)}>
                        <i className="bi bi-file-earmark-text me-1"></i> Report
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Report Modal */}
      {selectedLog && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header border-0 p-4">
                <h5 className="modal-title fw-800">Upload Report - {selectedLog.type?.toUpperCase()}</h5>
                <button type="button" className="btn-close" onClick={() => setSelectedLog(null)}></button>
              </div>
              <div className="modal-body p-0">
                <div className="p-4 bg-light">
                  <div className="row text-center">
                    <div className="col-4">
                      <div className="text-xs text-muted mb-1">TOTAL</div>
                      <div className="h4 fw-800 mb-0">{selectedLog.total_records}</div>
                    </div>
                    <div className="col-4 border-start">
                      <div className="text-xs text-muted mb-1 text-success">SUCCESS</div>
                      <div className="h4 fw-800 mb-0 text-success">{selectedLog.success_count}</div>
                    </div>
                    <div className="col-4 border-start">
                      <div className="text-xs text-muted mb-1 text-danger">ERRORS</div>
                      <div className="h4 fw-800 mb-0 text-danger">{selectedLog.error_count}</div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive" style={{ maxHeight: '400px' }}>
                  <table className="table table-sm align-middle mb-0">
                    <thead className="sticky-top bg-white border-bottom">
                      <tr>
                        <th className="ps-4">Row</th>
                        <th>Identifier</th>
                        <th>Status</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedLog.details?.map((detail, idx) => (
                        <tr key={idx}>
                          <td className="ps-4 text-xs">{detail.row}</td>
                          <td className="text-xs fw-600">{detail.phone || detail.customerId}</td>
                          <td>
                            <span className={`badge badge-soft-${detail.status === 'error' ? 'danger' : 'success'} text-xs`}>
                              {detail.status?.toUpperCase()}
                            </span>
                          </td>
                          <td className="text-xs text-muted">{detail.error || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer border-0 p-4">
                <button type="button" className="btn btn-light px-4" onClick={() => setSelectedLog(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemLogs;
